import { ContactUsButton } from "@/components/ContactUsButton";
import { IconQuestionChat } from "@/components/Icons/IconQuestionChat";
import { MappedLearningOpportunity } from "@/server/backend-api";
import { mcn } from "@/utils/mergeClassNames";
import { BaseContext } from "../BaseContext";
export type ContactInfoProps = {
  link?: boolean;
  base?: BaseContext;
  learningOpp?: MappedLearningOpportunity;
  LO_GENERAL_QUESTION?: string;
};
export const ContactInfo = ({
  base,
  learningOpp,
  LO_GENERAL_QUESTION,
}: ContactInfoProps) => {
  return (
    <div className={mcn("flex gap-xs items-center text-black")}>
      <IconQuestionChat className="size-[40px]" />
      <div className="flex flex-col">
        <div className="text-style-subtitle2">Need help?</div>
        <div className="text-style-body2">
          Reach out to us via this{" "}
          {
            <ContactUsButton
              className="w-fit mt-1"
              text="contact form"
              isAButton={false}
              formProps={{
                presets: {
                  learningOppId: learningOpp?.id,
                  contactFormSetting: base?.contactFormSettings.find(
                    (x) => x.name === LO_GENERAL_QUESTION
                  ),
                },
              }}
              memberUniversities={base?.memberUniversities}
              contactFormSettings={base?.contactFormSettings}
              learningOppNames={base?.learningOppNames}
            />
          }
        </div>
      </div>
    </div>
  );
};
